import { HttpClient } from '@angular/common/http';
var SilentAuthService = /** @class */ (function () {
    function SilentAuthService(httpClient) {
        this.httpClient = httpClient;
    }
    SilentAuthService.prototype.retrieveJwtToken = function () {
        var silentAuthUrl = 'http://localhost:83/silent-auth/jwt-redirect/private/jwt-service';
        return this.httpClient.get(silentAuthUrl, {
            responseType: 'text',
            withCredentials: true
        });
    };
    return SilentAuthService;
}());
export { SilentAuthService };
